// ═══════════════════════════════════════════════════════════
// DATOS — Generador de Propuestas Low Travel
// ═══════════════════════════════════════════════════════════

export const CIUDADES_SALIDA = ["Buenos Aires","Córdoba","Mendoza","Rosario","Salta","Tucuman","Bariloche","Otros"]

export const AEROLINEAS = [
  { key:"ARG", label:"Aerolíneas Argentinas", logo:"/logos/aerolineas.png"},
  { key:"GOL", label:"GOL",                  logo:"/logos/gol.png"       },
  { key:"LAT", label:"LATAM",                logo:"/logos/latam.png"     },
  { key:"JET", label:"JetSmart",              logo:"/logos/jetsmart.png"  },
  { key:"ARA", label:"Arajet",                logo:"/logos/arajet.png"    },
  { key:"COP", label:"Copa Airlines",         logo:"/logos/copa.png"      },
  { key:"AVI", label:"Avianca",               logo:"/logos/avianca.png"   },
  //{ key:"FLY", label:"Flybondi",              logo:"/logos/flybondi.png"  },
]

export const INCLUYE_OPTS = [
  { key:"aereos",       label:"✈️ Aéreos",                default:true  },
  { key:"hospedaje",    label:"🏨 Hospedaje",              default:true  },
  { key:"traslados",    label:"🚐 Traslados",              default:true  },
  { key:"comunicacion", label:"📞 Comunicación 24hs",      default:true  },
  { key:"desayuno",     label:"☕ Desayuno",               default:true  },
  { key:"mediaP",       label:"🍽️ Media Pensión",         default:false },
  { key:"allInc",       label:"🍹 All Inclusive",          default:false },
  { key:"asistencia",   label:"🛡️ Asistencia al Viajero", default:false },
]

export const REGALO_OPTS = [
  { key:"cityTourArraial", label:"🗺️ City tour Arraial do Cabo" },
  { key:"cityTourCabo",    label:"🗺️ City tour Cabo Frío"       },
  { key:"escuna",          label:"⛵ Paseo en escuna"            },
  { key:"cena",            label:"🍷 Cena"                       },
  { key:"mochila",         label:"🎒 Mochila viajera"            },
  { key:"carryOn",         label:"🧳 Carry on"                   },
  { key:"libre",           label:"✏️ Regalo personalizado"       },
]

export const CAT_COLORS = {
  "Económico": "#3b82f6",
  "Intermedio": "#10b981",
  "Exclusivo":  "#f59e0b",
}

export const CAT_BG = {
  "Económico": { bg:"#dbeafe", color:"#1e40af" },
  "Intermedio":{ bg:"#d1fae5", color:"#065f46" },
  "Exclusivo": { bg:"#fef3c7", color:"#92400e" },
}

export const HOTELES = {
  "Búzios":[
    //{cat:"Económico", n:"Nascimiento Suites",        u:"Zona Céntrica",                   d:"Ubicación estratégica en el centro de Búzios"},
    //{cat:"Económico", n:"Casa Serra Alves",           u:"Zona Geriba",                    d:"Tiene pileta y jardín"},
    {cat:"Económico", n:"Kybalion",                   u:"Zona Tartaruga",                  d:"Ubicación estratégica sobre la avenida principal, muy buena atención y confort"},
    {cat:"Económico", n:"Dos Coqueiros",              u:"Zona Tartaruga",                  d:"Tiene pileta"},
    {cat:"Económico", n:"Arambaré",                   u:"Zona Geribaú",                    d:"Tiene pileta, mesa de pool y ping pong"},
    //{cat:"Económico", n:"Maktub",                     u:"Zona Geriba",                    d:"Tiene pileta"},
    {cat:"Intermedio",n:"Da Ferradura",               u:"Próximo a playa Ferradura",       d:"Tiene pileta. Para pasar más tiempo en la playa"},
    {cat:"Intermedio",n:"Casa Centro Búzios",         u:"Zona Céntrica",                   d:"Para aprovechar la noche y el centro de Búzios"},
    //{cat:"Intermedio",n:"Buzios Centro Hotel",        u:"Próximo al centro",               d:"Tiene pileta"},
    {cat:"Intermedio",n:"Hotel Miratlantico Búzios",  u:"Zona Ferradura",                  d:"Tiene pileta y sauna"},
    {cat:"Intermedio",n:"Dos Reis",                   u:"Zona Tartaruga",                  d:"Tiene pileta, jardín, parrilla y bar. Espectacular confort y descanso"},
    //{cat:"Intermedio",n:"Riviera Búzios",             u:"Centro de Búzios",                d:"A 2 cuadras de la playa"},
    {cat:"Intermedio",n:"Dos Guardianes",             u:"A 2 cuadras de playa Ferradura",  d:"Tiene pileta y mesa de pool"},
    {cat:"Exclusivo", n:"Casagrande Hotel Boutique",  u:"A una cuadra de la playa",        d:"Tiene pileta"},
    {cat:"Exclusivo", n:"Barra da Lagoa",             u:"A 3 cuadras de la playa y el centro", d:"Tiene pileta y mucho confort en las habitaciones"},
    {cat:"Exclusivo", n:"Gammel Dansk",               u:"A 6 cuadras de la playa y el centro", d:"Tiene pileta y mucho confort en las habitaciones"},
    //{cat:"Exclusivo", n:"Coronado Inn",               u:"A 1 cuadra de playa Joao Fernandes", d:"Tiene pileta y sauna"},
    {cat:"Exclusivo", n:"Don Quijote Hotel",          u:"Zona Céntrica",                   d:"Tiene pileta. Para disfrutar de la noche de Búzios"},
    //{cat:"Exclusivo", n:"Pousada Encanto de Búzios",  u:"Búzios",                          d:"Tiene pileta y parrilla"},
    //{cat:"Exclusivo", n:"Blue Marlin",                u:"Frente a playa Geriba",          d:"Tiene pileta. Para pasar tiempo en la playa y en el hotel"},
    {cat:"Exclusivo", n:"Mar Joao Fernandes",         u:"A 2 cuadras de playa Joao Fernandes", d:"Tiene pileta"},
    {cat:"Exclusivo", n:"La Proeza",                  u:"Próximo a Joao Fernandes",        d:"Tiene pileta, minibar, alquiler de bicicletas, biblioteca, pesca, senderismo, zona de bronceado y buceo"},
    {cat:"Exclusivo", n:"Colonna Galapagos Garden",   u:"Frente a playa Joao Fernandes",   d:"Tiene pileta"},
  ],
  "Río de Janeiro":[
    {cat:"Económico", n:"Rede Andrade Hotel",         u:"A 2 cuadras de playa Copacabana", d:"Especial para conocer Río. Buena relación precio-calidad"},
    {cat:"Económico", n:"Hotel Atlántico Rio",        u:"A 5 cuadras de la playa",         d:"Bien ubicado en Copacabana"},
    {cat:"Intermedio",n:"Astoria Copacabana",         u:"A 2 cuadras de la playa",         d:"Tiene pileta"},
    {cat:"Intermedio",n:"Majestic Rio Palace",        u:"A 7 cuadras de la playa",         d:"Tiene pileta, gimnasio y sauna"},
    {cat:"Intermedio",n:"Regency Copacabana Hotel",   u:"A 5 cuadras de playa Copacabana", d:"Cómodo y bien ubicado"},
    {cat:"Intermedio",n:"Royalty Copacabana Hotel",   u:"Copacabana",                      d:"Tiene pileta en la terraza, gimnasio y sauna"},
    {cat:"Exclusivo", n:"Savoy Othon",                u:"A 2 cuadras de la playa",         d:"Tiene gimnasio y mesa de pool"},
    {cat:"Exclusivo", n:"Rio Othon Palace",           u:"Frente a la playa",               d:"Tiene pileta, vistas al mar y gimnasio"},
    {cat:"Exclusivo", n:"Augusto's Rio Copa Hotel",   u:"A 5 cuadras de la playa",         d:"Tiene pileta, gimnasio y sauna"},
    {cat: "Exclusivo", n:"Mar Palace Copacabana Hotel", u:"", d:""},
    {cat:"Exclusivo", n:"Royalty Rio Hotel",          u:"A 5 cuadras de la playa",         d:"Tiene gimnasio"},
  ],
  "Arraial do Cabo":[
    {cat:"Intermedio",n:"Dos Anjos",                  u:"A 2 cuadras de Praia dos Anjos",  d:"Bien ubicado en el pueblo"},
    {cat:"Intermedio",n:"Xerxes",                     u:"A 6 cuadras de Praia Prainha",    d:"Tiene pileta, parrilla y sauna"},
    {cat:"Intermedio",n:"Genesis",                    u:"A 5 cuadras de Praia Grande",     d:"Tiene pileta y parrilla"},
    {cat:"Intermedio",n:"Entre Mares",                u:"A 5 cuadras de Praia Grande",     d:"Zona tranquila y bien ubicado"},
    {cat:"Intermedio",n:"Bougainville Suites",        u:"A 2 cuadras de Praia dos Anjos",  d:"Cómodo y bien ubicado"},
    {cat:"Exclusivo", n:"Ocean View",                 u:"Frente a playa Prainha",          d:"Tiene pileta y vista al mar. Mucho confort"},
    {cat:"Exclusivo", n:"Loft Praia dos Anjos",       u:"A 2 cuadras de Praia dos Anjos",  d:"Tiene pileta y mesa de pool"},
  ],
  "Cabo Frío":[
    {cat:"Intermedio",n:"Pousada Laguna",             u:"Frente a la playa",               d:"Tiene pileta. Lejos del centro"},
    {cat:"Intermedio",n:"Pousada Porto Fino",         u:"A 5 cuadras de la playa",         d:"Bien ubicada"},
    {cat:"Intermedio",n:"Mirante do Forte",           u:"Cerca del centro",                d:"A 2 cuadras de la playa"},
    {cat:"Intermedio",n:"Pousada de Albatroz",        u:"Frente a la playa",               d:"Tiene pileta y mesa de pool. Lejos del centro"},
    {cat:"Intermedio",n:"Green Hoteis",               u:"Cerca del centro",                d:"A 7 cuadras de Praia Mirante do Forte"},
    {cat:"Exclusivo", n:"Pier Beach Club",            u:"Frente a la playa",               d:"Muy cómoda. Lejos del centro"},
  ],
  "Florianópolis":[
    {cat:"Economico",n:"Hanna Praia Hotel",          u:"",                                d:""},
    {cat:"Economico",n:"Apart Hotel Marazul",        u:"A 4 cuadras de la playa",         d:"Tiene cocina y heladera (sin desayuno)"},
    {cat:"Economico",n:"Apart Hotel Marazul 2",      u:"A 3 cuadras de la playa",         d:"Tiene cocina y heladera (sin desayuno)"},
    {cat:"Intermedio",n:"Elite Hotel",               u:"A 4 cuadras de la playa",         d:""},
    {cat:"Exclusivo",n:"Porto Madero",               u:"A 2 cuadras de la playa",         d:""},
    {cat:"Exclusivo",n:"Pousada Dos Golfinhos",      u:"Frente a la playa",               d:""},
    {cat:"Exclusivo",n:"Hotel Canasvieiras",         u:"Frente a la playa",               d:"Tiene Pileta"},
    //{cat:"Intermedio",n:"Balmare",                    u:"A 2 cuadras de la playa",         d:"Tiene pileta, mesa de pool y ping pong, cancha de tenis, gimnasio y parrilla"},
    //{cat:"Exclusivo", n:"Hotel Monteiro Canasvieiras",u:"Frente a playa Canasvieiras",     d:"Tiene sauna e hidromasajes"},
    //{cat:"Exclusivo", n:"Varadero Palace",            u:"A 1 cuadra de la playa",          d:"Tiene pileta, mesa de pool y ping pong y sauna"},
    {cat:"Exclusivo", n:"Tissiano",                   u:"A 1 cuadra de la playa",          d:"Tiene pileta y parrilla"},
  ],
  "Porto Galinhas":[
    {cat:"Intermedio",n:"Pousada Espacio Viana",      u:"A 3 cuadras de la playa",         d:"En el centro. Tiene pileta"},
    {cat:"Intermedio",n:"Pousada Porto de Galinhas",  u:"A 4 cuadras de la playa",         d:"Tiene pileta"},
    {cat:"Intermedio",n:"Pousada Sao Jorge",          u:"A 2 cuadras de la playa",         d:"En el centro"},
    {cat:"Intermedio",n:"Pousada Agua Viva",          u:"Frente a la playa",               d:"Tiene pileta"},
    //{cat:"Exclusivo", n:"Tabapitanga Resort",       u:"Porto Galinhas",                  d:"Frente a las piscinas naturales, todo incluido"},
    //{cat:"Exclusivo", n:"Nannai Resort & Spa",      u:"Muro Alto",                       d:"El resort más exclusivo de la región, playa privada"},
    {cat:"Exclusivo", n:"Marie Claire Flats",         u:"A 2 cuadras de la playa",         d:"Tiene pileta y Pool"}
  ],
  "Maragogi":[
    {cat:"Económico", n:"Pousada La Balle",           u:"A 6 cuadras de playa do Camacho", d:"Zona tranquila cerca del pueblo"},
    {cat:"Económico", n:"Pousada Dos Corais",         u:"A 4 cuadras de la playa",         d:"Tiene pileta"},
    {cat:"Intermedio",n:"Pousada Shalom Beach",       u:"Frente a la playa",               d:"Tiene pileta"},
    {cat:"Intermedio",n:"Pousada Maragolfinho",       u:"A 3 cuadras de la playa",         d:"Tiene pileta"},
    {cat:"Intermedio",n:"Sete Mares",                 u:"Zona Praia do Camacho",           d:"A 1 cuadra de la playa. Excelente base para explorar las piscinas naturales"},
    {cat:"Intermedio",n:"Pousada Taleiras",           u:"A 2 cuadras de la playa",         d:"Tiene pileta y parrilla"},
    {cat:"Exclusivo", n:"Pousada Ecohar Yoga",        u:"Frente a la playa",               d:"Tiene pileta, restaurante, biblioteca y yoga"},
    {cat:"Exclusivo", n:"Pousada Tartaruga",          u:"A una cuadra de la playa",        d:"Tiene pileta y vista al mar"},
    {cat:"Exclusivo", n:"Pousada Tropical Maragogi",  u:"A una cuadra de la playa",        d:"Tiene pileta y vista al mar"},
  ],
  "Maceió":[
    {cat:"Económico", n:"Conde Hotel Maceio",         u:"Cruz das Almas",                  d:"A 2 cuadras de la playa"},
    {cat:"Económico", n:"Hotel Flix",                 u:"A 2 cuadras de playa Jatiuca",    d:"Tiene pileta"},
    {cat:"Intermedio",n:"Hotel Refugio",              u:"A 2 cuadras de Praia do Pajuçara",d:"Zona tranquila y bien ubicado"},
    {cat:"Intermedio",n:"San Marino Suite Hotel",     u:"Zona Ponta Verde",                d:"A 2 cuadras de la playa. Tiene pileta, gimnasio y bar"},
    {cat:"Intermedio",n:"Hotel Ponta Verde",          u:"Frente a playa Ponta Verde",      d:"Tiene pileta y vista al mar"},
    {cat:"Exclusivo", n:"Ritz Suites Grand Hotel",    u:"Frente a playa Cruz das Almas",   d:"Tiene pileta, gimnasio y bar"},
    {cat:"Exclusivo", n:"Slim Pajuçara",              u:"A una cuadra de playa Pajuçara",  d:"Es la playa con aguas más calmas de Maceió. Mucho confort, tiene pileta"},
    {cat:"Exclusivo", n:"Verano Pajuçara",            u:"A 1 cuadra de playa Pajuçara",    d:"Tiene pileta"},
    {cat:"Exclusivo", n:"Hilton Garden Inn",          u:"A 2 cuadras de playa Pajuçara",   d:"Tiene pileta. Estándares internacionales garantizados"},
  ],
  "Punta Cana":[
    {cat:"Intermedio",n:"Honky Tonk",                 u:"A 2 cuadras de la playa",         d:"Con desayuno incluido"},
    {cat:"Intermedio",n:"Green Coast",                u:"A 3 cuadras de la playa",         d:"Con desayuno incluido. Tiene spa"},
    {cat:"Intermedio",n:"Los Corales",                u:"Frente a la playa",               d:"Con desayuno incluido. Tiene pileta, campo de golf, buceo y windsurf"},
    {cat:"Exclusivo", n:"Whala! Bávaro",              u:"Frente a la playa",               d:"All inclusive. Tiene pileta, gimnasio, sauna, alquiler de bicicletas, barbacoa, billar, parrilla, pesca y zona de bronceado"},
    {cat:"Exclusivo", n:"Vik Arena",                  u:"Frente a la playa",               d:"All inclusive. Tiene pileta, mesa de pool, casino, club nocturno, zona de bronceado, buceo, golf, gimnasio, cancha de tenis, ping pong y windsurf"},
  ],
  "Cancún":[
    {cat:"Intermedio",n:"Ocean View Cancun Arenas",   u:"Frente a la playa zona norte",    d:"All inclusive. Tiene pileta, salida al mar, gimnasio, mesa de ping pong y spa"},
    {cat:"Intermedio",n:"Hotel Dos Playas Faranda",   u:"Frente a playa Tortugas",         d:"All inclusive. Tiene pileta, cancha de tenis, gimnasio, parrilla, ping pong, buceo y campo de golf"},
  ],
  "Cartagena":[
    {cat:"Económico", n:"Hotel Azuan Suites",         u:"A 3 cuadras de la playa",         d:"Solo desayuno"},
    {cat:"Intermedio",n:"Casa Franco Hotel",          u:"A 4 cuadras de la playa",         d:"Hotel con mucho confort. Solo desayuno"},
    {cat:"Intermedio",n:"Hotel Costa del Sol",        u:"Frente al mar",                   d:"Vista al mar y pileta. Solo desayuno"},
    {cat:"Exclusivo", n:"Hotel Cartagena Plaza",      u:"Frente al mar",                   d:"All inclusive. Tiene vista al mar, pileta, mesa de ping pong, pool y gimnasio"},
  ],
  "Bayahibe":[
    {cat:"Exclusivo", n:"HM Alma De Bayahibe",        u:"Bayahibe (Adults Only)",          d:"All inclusive. Tiene pileta, mesa de pool, gimnasio, ping pong y muy buenas vistas"},
  ],
  /*"Playa del Carmen":[
    {cat:"Exclusivo", n:"Viva Wyndham Maya",          u:"Frente a la playa",               d:"All inclusive. Tiene pileta, jardín, cancha de tenis, gimnasio y salida a la playa"},
  ],
  "Panamá":[
    {cat:"Intermedio",n:"Faranda Express Soloy",      u:"Centro de Ciudad de Panamá",      d:"Solo desayuno. Tiene piscina en la azotea con vista a la ciudad y casino. Ideal para compras y tours"},
  ],
  "Playa Blanca":[
    {cat:"Exclusivo", n:"Playa Blanca Hotel & Resort",u:"Frente a la playa del Pacífico",  d:"Todo incluido. Tiene 2 piscinas, acceso a laguna gigante, mesa de pool, ping pong, bar y actividades recreativas"},
  ],*/
}

export const DESTINOS = Object.keys(HOTELES)

export const DESTINO_IMGS = {
  "Búzios":          "/destinos/buzios.jpg",
  "Maragogi":        "/destinos/maragogi.jpg",
  "Maceió":          "/destinos/maceio.jpg",
  "Río de Janeiro":  "/destinos/rio-de-janeiro.jpg",
  "Arraial do Cabo": "/destinos/arraial-do-cabo.jpg",
  "Cabo Frío":       "/destinos/cabo-frio.jpg",
  "Florianópolis":   "/destinos/florianopolis.jpg",
  "Punta Cana":      "/destinos/punta-cana.jpg",
  "Porto Galinhas":  "/destinos/porto-galinhas.jpg",
  "Cancún":          "/destinos/cancun.jpg",
  "Cartagena":       "/destinos/cartagena.jpg",
  "Bayahibe":        "/destinos/bayahibe.jpg",
  "Playa del Carmen":"/destinos/playa-del-carmen.jpg",
  "Panamá":          "/destinos/panama.jpg",
  "Playa Blanca":    "/destinos/playa-blanca.jpg",
}

const HOY = new Date()
export const HOY_STR = `${String(HOY.getDate()).padStart(2,"0")}/${String(HOY.getMonth()+1).padStart(2,"0")}/${HOY.getFullYear()}`
const AÑO = HOY.getFullYear()
export const FECHA_SAL_DEF = '2027-01-02'//`${AÑO}-011-01`
export const FECHA_REG_DEF = '2027-01-09'//`${AÑO}-011-08`

export const FORM_VACIO = {
  cliente: "",
  fechaSalida: FECHA_SAL_DEF,
  fechaRegreso: FECHA_REG_DEF,
  ciudadSalida: "Buenos Aires",
  ciudadOtra: "",
  aerolinea: "ARG",
  equipaje: { mochila:true, carryOn:true, valija:false, cantValijas:1 },
  destino1: "", noches1: "7", hoteles1: {}, destino1Libre: "",
  destino2: "", noches2: "7", hoteles2: {}, destino2Libre: "",
  incluye: Object.fromEntries(INCLUYE_OPTS.map(o=>[o.key, o.default])),
  regalo: Object.fromEntries(REGALO_OPTS.map(o=>[o.key, false])),
  cenaCantidad: "2",
  regaloLibreTexto: "",
  precio: { modo: "oculto", total: "", reserva: "", pax: "2", cuotas: "6", rangoMin: "", rangoMax: "" },
}

export function formatFecha(str) {
  if (!str) return "—"
  const [y,m,d] = str.split("-")
  return `${d}/${m}/${y}`
}

export function getIncluye(inc) {
  const items = []
  if (inc.aereos)       items.push("✈️ Aéreos")
  if (inc.hospedaje)    items.push("🏨 Hospedaje")
  if (inc.traslados)    items.push("🚐 Traslados")
  if (inc.comunicacion) items.push("📞 Comunicación 24hs")
  if (inc.allInc) {
    items.push("🍹 All Inclusive")
  } else {
    if (inc.mediaP)        items.push("🍽️ Media Pensión")
    else if (inc.desayuno) items.push("☕ Desayuno")
  }
  if (inc.asistencia) items.push("🛡️ Asistencia al Viajero")
  return items
}

export function getRegalo(regalo, cenaCantidad, regaloLibreTexto) {
  const items = []
  if (regalo.cityTourArraial) items.push("🗺️ City tour Arraial do Cabo")
  if (regalo.cityTourCabo)    items.push("🗺️ City tour Cabo Frío")
  if (regalo.escuna)          items.push("⛵ Paseo en escuna")
  if (regalo.cena)            items.push(`🍷 Cena para ${cenaCantidad} personas`)
  if (regalo.mochila)         items.push("🎒 Mochila viajera")
  if (regalo.carryOn)         items.push("🧳 Carry on")
  if (regalo.libre && regaloLibreTexto?.trim()) items.push(`✏️ ${regaloLibreTexto.trim()}`)
  return items
}

export function getEquipaje(eq) {
  const e = []
  if (eq.mochila)  e.push("Mochila")
  if (eq.carryOn)  e.push("Carry On")
  if (eq.valija)   e.push(`${eq.cantValijas > 1 ? eq.cantValijas+"x " : ""}Valija 23kg`)
  return e.join(" · ")
}

export function getWAText(form) {
  const aero = AEROLINEAS.find(a=>a.key===form.aerolinea)
  const ciudad = form.ciudadSalida==="Otros" ? form.ciudadOtra : form.ciudadSalida
  const lineas = []
  lineas.push(`✈️ *PROPUESTA DE VIAJE — LOW TRAVEL*`)
  if (form.cliente) lineas.push(`👤 Para: ${form.cliente}`)
  lineas.push("")
  const dest1Name = form.destino1 === "Libre" ? (form.destino1Libre?.trim() || "Destino libre") : form.destino1
  const dest2Name = form.destino2 === "Libre" ? (form.destino2Libre?.trim() || "Destino libre") : form.destino2
  if (dest1Name) lineas.push(`📍 *${dest1Name}*${dest2Name?" + "+dest2Name:""}`)
  if (form.fechaSalida) lineas.push(`📅 Salida: ${formatFecha(form.fechaSalida)}`)
  if (form.fechaRegreso) lineas.push(`📅 Regreso: ${formatFecha(form.fechaRegreso)}`)
  if (aero) lineas.push(`✈️ Aerolínea: ${aero.label}`)
  if (ciudad) lineas.push(`🏙️ Desde: ${ciudad}`)
  const eq = getEquipaje(form.equipaje)
  if (eq) lineas.push(`🧳 Equipaje: ${eq}`)
  lineas.push("")

  const renderDest = (destino, destinoName, noches, hoteles) => {
    if (!destino) return
    lineas.push(`*${destinoName}* — ${noches} noches`)
    Object.entries(hoteles).filter(([,v])=>v.sel).forEach(([nombre, val]) => {
      let precioStr = val.precio ? `USD ${val.precio}` : ""
      if (val.tachado) precioStr += ` (antes USD ${val.tachado})`
      // Clave global nueva (sin tier)
      if (nombre === "__aeleccion__") {
        lineas.push(`  • A elección`)
        if (precioStr) lineas.push(`    💰 ${precioStr}`)
        return
      }
      if (nombre === "__libre__" || /^__libre\d+__$/.test(nombre)) {
        const displayName = val.nombre?.trim() || "Hotel a definir"
        lineas.push(`  • ${displayName}`)
        if (precioStr) lineas.push(`    💰 ${precioStr}`)
        return
      }
      // Legacy con tier (retrocompatibilidad)
      if (nombre.startsWith("__aeleccion__")) {
        const cat = nombre.replace("__aeleccion__","")
        lineas.push(`  • ${cat} | A elección`)
        if (precioStr) lineas.push(`    💰 ${precioStr}`)
        return
      }
      if (nombre.startsWith("__libre__")) {
        const cat = nombre.replace("__libre__","")
        const displayName = val.nombre?.trim() || "Hotel a definir"
        lineas.push(`  • ${cat} | ${displayName}`)
        if (precioStr) lineas.push(`    💰 ${precioStr}`)
        return
      }
      const hotel = HOTELES[destino]?.find(h=>h.n===nombre)
      if (!hotel) return
      lineas.push(`  • ${hotel.cat} | ${nombre} — ${hotel.u}`)
      if (precioStr) lineas.push(`    💰 ${precioStr}`)
    })
  }
  renderDest(form.destino1, dest1Name, form.noches1, form.hoteles1)
  if (form.destino2) renderDest(form.destino2, dest2Name, form.noches2, form.hoteles2)

  lineas.push("")
  const inc = getIncluye(form.incluye)
  if (inc.length) lineas.push(`📦 *Incluye:* ${inc.join(" · ")}`)

  const reg = getRegalo(form.regalo, form.cenaCantidad, form.regaloLibreTexto)
  if (reg.length) {
    lineas.push("")
    lineas.push(`🎁 *Regalo incluido:*`)
    reg.forEach(r => lineas.push(`  • ${r}`))
  }

  const p = form.precio || {}
  const n = s => Number(String(s).replace(/,/g, ""))
  if (p.modo === "total" && p.total) {
    lineas.push(`💰 *Precio:* USD ${n(p.total).toLocaleString("es-AR")} por persona`)
  } else if (p.modo === "cuotas" && p.reserva && p.cuotas) {
    const paxNum    = n(p.pax) || 1
    const reservaPP = Math.round(n(p.reserva) / paxNum)
    const cuotaMonto = p.total
      ? Math.ceil((n(p.total) - reservaPP) / n(p.cuotas))
      : null
    const cuotaStr = cuotaMonto ? ` de USD ${cuotaMonto.toLocaleString("es-AR")}` : ""
    lineas.push(`💰 *Plan de pago:* Reservá con USD ${reservaPP.toLocaleString("es-AR")} + ${p.cuotas} cuotas${cuotaStr} por persona`)
  } else if (p.modo === "rango" && p.rangoMin && p.rangoMax) {
    lineas.push(`💰 *Precio:* Entre USD ${n(p.rangoMin).toLocaleString("es-AR")} y USD ${n(p.rangoMax).toLocaleString("es-AR")} por persona`)
  }
  lineas.push("")
  lineas.push(`📆 Cotización: ${HOY_STR}`)
  lineas.push(`⚠️ El precio se mantiene por 48hs`)
  return lineas.join("\n")
}